import React from 'react'
import { Card } from 'material-ui/Card'
import styles from './styles.css'

export default function ErrorMessage() {
  const CardStyles = {
    boxShadow: '0 12px 15px 0 rgba(0,0,0,.1), 0 30px 80px 0 rgba(0,0,0,.2)',
  }

  const ContainerStyles = {
    display: 'block',
    padding: '20px',
    background: 'rgba(74, 205, 222, .15)',
    color: '#424242',
    textAlign: 'center',
  }

  return (
    <div className={styles.errorComp}>
      <div className={styles.errorCont}>
        <Card
          containerStyle={ContainerStyles}
          expandable={false}
          style={CardStyles}
        >
          <h2>We could not find any appointment types available for online scheduling.</h2>
          <h3>Please log into Cloud9 to indicate which appointment types should be available for new and existing patient online scheduling</h3>
        </Card>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/AppointmentTypes/ErrorMessage.js